import { createContext, useContext } from 'react';

interface PlaceholderContainerContextData {
  isInsidePlaceholder: boolean;
}
export const PlaceholderContainerContext = createContext<
  PlaceholderContainerContextData | undefined
>(undefined);

export const usePlaceholderContainer = (): PlaceholderContainerContextData => {
  const context = useContext(PlaceholderContainerContext);
  return context ?? { isInsidePlaceholder: false };
};
